/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { createAsyncThunk } from "@reduxjs/toolkit";
import type {
  ProfileResponse,
  TProfileManagementServiceFetchProfileParams
} from "@tivocorp/data-domain-lib";

import { ProfileManagementInteractor } from "../../../model/interactor";
import { Locale, LocaleKeys } from "../../../model/locale";
import { Log } from "../../../model/logging";
import type { TProfileError } from "../profiles.types";
import { normalizeProfileError } from "../profileErrorHandling";

const TAG: string = "profileLoadingThunks";

export const loadProfile = createAsyncThunk<
  ProfileResponse,
  TProfileManagementServiceFetchProfileParams,
  { rejectValue: TProfileError | string }
>("profiles/loadProfile", async (params, { rejectWithValue, signal }) => {
  try {
    Log.d(TAG, "loadProfile() called");
    const interactor: ProfileManagementInteractor =
      new ProfileManagementInteractor();
    return await interactor.fetchProfile(params, { signal });
  } catch (error: unknown) {
    Log.e(TAG, "loadProfile()", error);
    return rejectWithValue(
      normalizeProfileError(
        error,
        Locale.getString(LocaleKeys.PROFILE_FETCH_FAILED_FALLBACK)
      )
    );
  }
});
